// frontend/src/components/BookBadge.tsx
// Solid-colour badge naming the book (Messer / Empire-ACA). Used wherever
// both books appear on one screen so no row or subtotal floats free.
import type { System } from '../lib/api';

export function bookColor(sys: System): string {
  return sys === 'Messer' ? 'var(--color-book-messer)' : 'var(--color-book-empire)';
}

export default function BookBadge({ sys, size = 'sm' }: { sys: System; size?: 'sm' | 'md' }) {
  const cls = sys === 'Messer' ? 'badge-book-messer' : 'badge-book-empire';
  return (
    <span
      className={`badge ${cls} font-semibold uppercase tracking-wider ${size === 'md' ? 'text-xs px-3 py-1' : 'text-[10px]'}`}
      title={sys}
    >
      {sys}
    </span>
  );
}
